import { displayAttendanceContactDeadline } from '@/service/parentContacts/displayAttendanceContactDeadline';
import { submitAttendanceContactDeadline } from '@/service/parentContacts/submitAttendanceContactDeadline';
import { toFormKind, fromFormKind } from '@/service/parentContacts/deadlineFormConverter';
import { isContactV3ApiBetaEnabled } from '@/service/parentContacts/isContactV3ApiBetaEnabled';

// 保護者からの連絡を確認済みに変更するリクエストで `mode: ['update_schedules']` を除外すべきかを判定。
// バック側は responses.service_id 基準で同等の判定を行うため、統括の全体モードでは判定をスキップしてバックに委ねる。
// 下位の isExistFeatureFlag / isBetaFacility が内部で例外を吸収して false を返すため、ここでの try/catch は不要。
const shouldExcludeUpdateSchedulesMode = (isWholeFacilitiesMode) => {
  if (isWholeFacilitiesMode) {
    return Promise.resolve(false);
  }
  return isContactV3ApiBetaEnabled();
};

angular.module('inspinia').factory('parentContactsService', function () {
  return {
    displayAttendanceContactDeadline,
    submitAttendanceContactDeadline,
    toFormKind,
    fromFormKind,
    isContactV3ApiBetaEnabled,
    shouldExcludeUpdateSchedulesMode,
  };
});
